import FieldDefs from './AdsFactsFieldDefs.js';
import {doLangFields} from '../../../lib/ks-tools';
import AdsSelector from "./mixins/Selector";

export default {
    template: `<div><slot v-bind="self"/></div>`,
    mixins: [AdsSelector],
    data() {
        return {
            fields: doLangFields(this, "lang.group_report.adsfacts", FieldDefs),
            sortOrder: [
                {
                    field: 'fact',
                    direction: 'asc'
                }
            ],
            moreParams: {},
            viewMode: '&view=facts',
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
